export default {"src":"/_next/static/media/background.998e7324.svg","height":768,"width":1280,"blurWidth":0,"blurHeight":0};